import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { BenchmarkOrderRequestDataImpl } from "../model/impl/BenchmarkOrderRequestDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class BenchmarkOrderRequestDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: BenchmarkOrderRequestDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.externalClientReference != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(1),
        false,
        encodable.externalClientReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCode != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(2),
        false,
        encodable.clientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.accountCode != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(3),
        false,
        encodable.accountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedAmount != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(4),
        false,
        encodable.fixedAmount,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.clientIntent != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(5),
        false,
        encodable.clientIntent,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.tenor != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(6),
        false,
        encodable.tenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.product != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(7),
        false,
        encodable.product,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.base != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(8),
        false,
        encodable.base,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBase != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(9),
        false,
        encodable.nonBase,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedCcy != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(10),
        false,
        encodable.fixedCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.comment != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(11),
        false,
        encodable.comment,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.comment2 != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(12),
        false,
        encodable.comment2,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingCode != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(13),
        false,
        encodable.fixingCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDate != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(14),
        true,
        encodable.fixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.benchmarkTime != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(15),
        true,
        encodable.benchmarkTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.rateSource != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(16),
        false,
        encodable.rateSource,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDateTime != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(17),
        false,
        encodable.fixingDateTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingTimeZone != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(18),
        false,
        encodable.fixingTimeZone,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.onBehalfOfCode != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(19),
        false,
        encodable.onBehalfOfCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "com.bcdfx.model.OrderIntent"],
    [6, "com.bcdfx.model.Tenor"],
    [7, "com.bcdfx.model.Product"],
    [8, "java.lang.String"],
    [9, "java.lang.String"],
    [10, "java.lang.String"],
    [11, "java.lang.String"],
    [12, "java.lang.String"],
    [13, "java.lang.String"],
    [14, "com.bcdfx.model.StandardDate"],
    [15, "com.bcdfx.model.Time"],
    [16, "java.lang.String"],
    [17, "java.util.Date"],
    [18, "java.lang.String"],
    [19, "java.lang.String"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: BenchmarkOrderRequestDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.externalClientReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.clientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.accountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.fixedAmount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.OrderIntent = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.clientIntent = <CubiqTS.OrderIntent>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.tenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Product = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.product = <CubiqTS.Product>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.base = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.nonBase = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.fixedCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.comment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.comment2 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.fixingCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.fixingDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.Time = this.baseEncoder.readObject(
            true,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.benchmarkTime = <CubiqTS.Time>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.rateSource = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.fixingDateTime = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.fixingTimeZone = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.onBehalfOfCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,BenchmarkOrderRequestDataImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return BenchmarkOrderRequestDataImplEncoder.fidTypeMap.has(fid);
  }
}
